<template>
  <div class="project-businesskit-assignement ">
    <assignment-modal
      :collection="filteredBusinesskits"
      :assignedCollection="assignedBusinessKitList"
      :title="computedTitle"
      :subtitle="computedSubtitle"
      :open="isOpen"
      searchPlaceholder="bk"
      displayName="name"
      @close="close"
      @save="save"
    />
    <div v-if="this.assignedBusinesskits.length === 0" class="empty-state-assignment">
      <img src="../../../assets/businesskit.svg">
      <p>{{$t('ui.pages.project-no-assigned-businesskit')}}</p>
      <div class="actions">
        <span
          class="btn btn-primary"
          @click="isOpen = true"
        >
          {{$t('ui.pages.project-assign-businesskit')}}
        </span>
      </div>
    </div>

    <div v-if="this.assignedBusinesskits.length > 0" class="project-businesskit-assignement--monitor">
      <h3>
        {{$t('ui.pages.project-assigned-businesskit')}}:
      </h3>
        <a
          class="link"
          @click="isOpen = true"
        >
          {{$t('ui.pages.project-assign-businesskit')}}
        </a>
      <div
        v-for="businesskit in assignedBusinessKitList"
        :key="businesskit.id"
        class="businesskit"
      >
      <div class="box">
        <img src="../../../assets/bk.svg">
        <div>
          <h4 class="businesskit-name">
            {{ businesskit.name }}
          </h4>
          <a
            v-if="businesskit.preview_url"
            class="link"
            :href="businesskit.preview_url"
            target="_blank"
          >
            Preview
          </a>
        </div>
      </div>
    </div>
  </div>
  <br/>

  </div>
</template>
<script>
import AssignmentModal from '@/components/layouts/partials/AssignmentModal'

export default{
  props: {
    businesskits: {
      type: Array
    },
    assignedBusinesskits: {
      type: Array
    }
  },
  components: {
    AssignmentModal
  },
  data() {
    return {
      isOpen: false,
    }
  },
  computed: {
    computedTitle() {
      return "businesskit_assignment.title"
    },
    computedSubtitle() {
      return "businesskit_assignment.subtitle"
    },
    assignedBusinessKitList() {
      let assignedBks = this.assignedBusinesskits
      return this.businesskits.filter((bk) => {
        return assignedBks.includes(bk.id)
      })
    },
    filteredBusinesskits() {
      // Put assigned at the top
      let c = this.businesskits.filter(item => !this.assignedBusinessKitList.includes(item))
      // Merge both collections together in correct order
      return [...this.assignedBusinessKitList, ...c]
    }
  },
  methods: {
    save(items) {
      let assignedBusinesskits = items.map((item) => {
        return item.id
      })
      this.close()
      this.$emit('update', assignedBusinesskits)
    },
    close() {
      this.isOpen = false
    }
  }
}
</script>
<style lang="sass" scoped>
.subtitle
  margin-left: 5px

.btn
  padding: 6px 15px

.businesskit
  margin-bottom: 10px
  &:first-of-type
    margin-top: 20px

  p
    margin-bottom: 0

  a
    font-weight: 500

.businesskit-name
  margin-bottom: 5px
  margin-top: 0
  color: $ink-dark
  font-size: 16px !important
  font-weight: 500 !important

.empty-state-assignment
  text-align: center
  p
    color: $ink-lighter
    margin-top: 20px
.actions
  margin-top: 20px

.project-businesskit-assignement--monitor
  h3
    font-size: 20px
    margin-bottom: 10px
    margin-top: 0
  a
    font-weight: 500
    cursor: pointer
.box
  background-color: $paper-lighter
  border-radius: 5px
  padding: 20px
  display: flex
  align-items: flex-start
  img
    margin-right: 15px

  p
    color: $ink-lighter
    font-size: 12px
    margin-top: 0px
</style>



// WEBPACK FOOTER //
// ProjectBusinesskitAssignement.vue?6aee4192